import {
  ArchiveOutlined,
  FactCheckOutlined,
  Inventory2Outlined,
  InventoryOutlined,
  OtherHousesOutlined,
  PeopleAltOutlined,
  PeopleOutline,
  PrecisionManufacturingOutlined,
  ReceiptLongOutlined,
  ReceiptOutlined,
  RequestQuoteOutlined,
  SellOutlined,
} from "@mui/icons-material";

import { MenuList, Stack, useTheme } from "@mui/material";
import {
  CustomerPermission,
  DeliveryNotesPermission,
  DualLangInspectionsPermission,
  EmployeePermission,
  MaterialInventoriesPermission,
  MaterialPermission,
  PackingNotesPermission,
  PaperMaterialInventoriesPermission,
  PaperMaterialsPermission,
  ProductInventoryPermission,
  ProductPermission,
  PurchaseOrdersPermission,
  QuotationsPermission,
  StellaInspectionsPermission,
  WorkOrdersPermission,
} from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { CommonTransKey } from "localization/translation-key/common";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStores } from "../../../mobx-stores/_root-store";
import { NavigationItem } from "./navigation-item";

export const Navigation = observer(() => {
  const { mainNavigationMinimize } = useStores();
  const { t } = useTranslation();
  const theme = useTheme();
  const customerAccess = useCheckPermission([CustomerPermission.Default]);
  const productAccess = useCheckPermission([ProductPermission.Default]);
  const orderAccess = useCheckPermission([PurchaseOrdersPermission.Default]);
  const productInventoryAccess = useCheckPermission([
    ProductInventoryPermission.Default,
    ProductInventoryPermission.Export,
    ProductInventoryPermission.Import,
  ]);
  const paperInventoryAccess = useCheckPermission([
    PaperMaterialsPermission.Default,
    PaperMaterialInventoriesPermission.Default,
    PaperMaterialInventoriesPermission.Issue,
    PaperMaterialInventoriesPermission.Receipt,
  ]);
  const materialInventoryAccess = useCheckPermission([
    MaterialPermission.Default,
    MaterialInventoriesPermission.Default,
    MaterialInventoriesPermission.Issue,
    MaterialInventoriesPermission.Receipt,
  ]);
  const deliveryNotesAccess = useCheckPermission([
    DeliveryNotesPermission.Default,
  ]);

  const employeesAccess = useCheckPermission([EmployeePermission.Default]);

  const workOrderAccess = useCheckPermission([WorkOrdersPermission.Default]);

  const workOrderPoAccess = useCheckPermission([WorkOrdersPermission.Default]);

  const quotationsAccess = useCheckPermission([QuotationsPermission.Default]);

  const inspectionAccess = useCheckPermission([
    StellaInspectionsPermission.Default,
  ]);

  const dualLangInspectionAccess = useCheckPermission([
    DualLangInspectionsPermission.Default,
  ]);

  const packingNotesAccess = useCheckPermission([
    PackingNotesPermission.Default,
  ]);

  return (
    <Stack
      component={"nav"}
      sx={{
        flexShrink: 0,
        flexDirection: "column",
        minHeight: 0,
        borderTop: mainNavigationMinimize
          ? `1px solid ${theme.palette.divider}`
          : undefined,
        borderRight: mainNavigationMinimize
          ? `1px solid ${theme.palette.divider}`
          : undefined,
        borderTopRightRadius: "16px",
        backgroundColor: mainNavigationMinimize ? "#E2E1EC" : undefined,
      }}
    >
      <MenuList dense sx={{ flex: "1 1 auto", minHeight: 0, overflow: "auto" }}>
        {customerAccess.allowAccess && (
          <NavigationItem to="/customers" icon={<PeopleAltOutlined />}>
            {t(CommonTransKey.customer)}
          </NavigationItem>
        )}

        {productAccess.allowAccess && (
          <NavigationItem
            to="/products"
            icon={<PrecisionManufacturingOutlined />}
          >
            {t(CommonTransKey.productAndTechnical)}
          </NavigationItem>
        )}

        {quotationsAccess.allowAccess && (
          <NavigationItem to="/quotations" icon={<RequestQuoteOutlined />}>
            {t(CommonTransKey.quotation)}
          </NavigationItem>
        )}

        {orderAccess.allowAccess && (
          <NavigationItem to="/orders" icon={<SellOutlined />}>
            {t(CommonTransKey.order)}
          </NavigationItem>
        )}

        {workOrderPoAccess.allowAccess && (
          <NavigationItem to="/work-orders-po" icon={<ReceiptLongOutlined />}>
            Lệnh sản xuất & Tiến độ
          </NavigationItem>
        )}

        {paperInventoryAccess.allowAccess && (
          <NavigationItem to="/papers-inventory" icon={<Inventory2Outlined />}>
            {t(CommonTransKey.paperWarehouse)}
          </NavigationItem>
        )}

        {productInventoryAccess.allowAccess && (
          <NavigationItem to="/products-inventory" icon={<InventoryOutlined />}>
            {t(CommonTransKey.productWarehouse)}
          </NavigationItem>
        )}

        {materialInventoryAccess.allowAccess && (
          <NavigationItem
            to="/materials-inventory"
            icon={<OtherHousesOutlined />}
          >
            {t(CommonTransKey.material)}
          </NavigationItem>
        )}

        {packingNotesAccess.allowAccess && (
          <NavigationItem to="/packing-notes" icon={<ArchiveOutlined />}>
            Phiếu đóng gói
          </NavigationItem>
        )}

        {(inspectionAccess.allowAccess ||
          dualLangInspectionAccess.allowAccess) && (
          <NavigationItem to="/inspection-notes" icon={<FactCheckOutlined />}>
            Phiếu kiểm nghiệm
          </NavigationItem>
        )}

        {deliveryNotesAccess.allowAccess && (
          <NavigationItem to="/delivery-notes" icon={<ReceiptOutlined />}>
            {t(CommonTransKey.receiptOfDelivery)}
          </NavigationItem>
        )}

        {employeesAccess.allowAccess && (
          <NavigationItem to="/employees" icon={<PeopleOutline />}>
            Phòng nhân sự
          </NavigationItem>
        )}

        {/* <NavigationItem to="/example">Example</NavigationItem> */}
      </MenuList>
    </Stack>
  );
});
